/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, August 11th 2022, 3:04:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { DatasetReferenceSelectInput } from "datasets/components/DatasetReferenceSelectInput";

export const DatasetUpdateTaskSettings = () => (
  <DatasetReferenceSelectInput<TaskTemplate> schema_field_key="dataset_reference" settingsType="data_update" />
);
